// extracted by mini-css-extract-plugin
export default {"PurchaseList":"PurchaseList_PurchaseList__GdLua"};